import React from "react"
import { useSelector } from "react-redux"

import { IRedux } from "../services/types"

const Footer = () => {
  const settings = useSelector((state: IRedux) => state.settings?.extended)
  const event = useSelector((state: IRedux) => state.event)

  if (!event || !settings || !settings.footerImg) return null

  return (
    <img
      alt="footer"
      src={`https://puzzle-system-files.s3.eu-west-3.amazonaws.com/front_office/footers/${settings.footerImg}`}
      style={{ width: "100%" }}
    />
  )
}

export default Footer
